"use client"

import { useChatCountsUpdater } from "@/hooks/useChatCountUpdater"

interface Props {
  uuid: string
  messagingToken: string
}

export const ChatCountUpdater: React.FC<Props> = ({ uuid, messagingToken }) => {
  // This hook is used to update the chat counts and should only be used once
  useChatCountsUpdater({ uuid, messagingToken })

  return null
}
